@if (showSpinner) {
<app-loader> </app-loader>
}

<main class="content-wrapper">
  <div class="main-wrapper">
    <div class="body-wrapper mt-2">

      <div class="heading-view">
        <h1 class="filter-txt">Attendance Correction Request</h1>
      </div>


      <!-- <div class="filter-container">
      <div class="left-filter">
        <h1 class="filter-txt">Filter</h1>
      </div>
      <form #f="ngForm" (ngSubmit)="onSubmit(f)">
        <div class="right-filter">

          <input type="text" class="search-input" placeholder="Search by name" />
          <select id="attendancetype" name="attendancetype" class="search-input" ngModel #attendancetype="ngModel">
            <option selected="true" disabled="disabled">Select Type</option>
            <option value="LastMonth">Last Month</option>
            <option value="ThisMonth">Current Month</option>
          </select>
          <input type="text" placeholder="Start Date" onfocus="(this.type='date')" name="startdate" id="startdate"
            class="date-picker" id="datetimepicker4" ngModel #startdate="ngModel" />
            <input type="text" onfocus="(this.type='date')" class="date-picker" placeholder="End Date" name="enddate"
              id="enddate" ngModel #enddate="ngModel" />
              <input type="text" placeholder="Start Date" onfocus="(this.type='date')" name="startdate" id="startdate"
                class="date-picker" id="datetimepicker4" ngModel />
                <input type="text" onfocus="(this.type='date')" class="date-picker" placeholder="End Date" name="enddate"
                  id="enddate" ngModel />
                  <button type="submit" class="apply-btn">Apply</button>

                </div>
              </form>
            </div> -->

      <!-- header start -->
      <div class="table-wrapper pb-1 mt-3 mb-2">
        <table>
          <tbody class="headerTable">
            <tr>
              <th>Request Type</th>
              <th>Added Value</th>
              <th>Requested Value</th>
              <th>Date</th>
              <th>Status</th>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- header end -->

      @for (item of attendanceRequest; track item) {
      <div class="table-wrapper pb-1">
        <div class="tbl-Border-style mb-2" [ngClass]="{
          'tbl-Border-color-approve': item.status === 'approved',
          'tbl-Border-color-reject': item.status === 'rejected',
          'tbl-Border-color-pending': item.status === 'pending' || item.status == null
        }">
          <table>
            <tbody [ngClass]="{
              'approve-tbody': item.status === 'approved',
              'reject-tbody': item.status === 'rejected',
              'pending-tbody': item.status === 'pending' || item.status == null
            }">
              <tr>
                <th>{{item.type | titlecase}}</th>
                <th>{{item.old_value}}</th>
                @if (item.type === 'check_in') {
                <th>{{item.check_in}}</th>
                }
                @if (item.type === 'check_out') {
                <th>{{item.check_out}}</th>
                }
                @if (item.type === 'overtime') {
                <th>{{item.overtime}}</th>
                }
                <th>{{item.date | date:'MMM dd, yyyy'}}</th>
                @if (item.status === 'approved') {
                <th>
                  <span class="badge all-good-badge"><img class="badge-icon"
                      src="../../../assets/attendance/check-circle.svg" alt="badge" /> Accepted </span>
                </th>
                }
                @if (item.status === 'rejected') {
                <th>
                  <span class="badge absent-badge"><img class="badge-icon" src="../../../assets/attendance/x-circle.svg"
                      alt="badge" /> Rejected </span>
                </th>
                }
                @if (item.status === 'pending' || item.status == null) {
                <th>
                  <span class="badge pending-badge"><img class="badge-icon"
                      src="../../../assets/attendance/alarm-clock-minus.svg" alt="badge" /> Pending </span>
                </th>
                }
                @if (item.monthly_sequence > 2) {
                <th>
                  <span style="background:#e53e3e;color:#fff;padding:3px 9px;border-radius:12px;font-size:11px;white-space:nowrap;">
                    {{ item.monthly_sequence }}{{ (item.monthly_sequence >= 11 && item.monthly_sequence <= 13) ? 'th' : item.monthly_sequence % 10 === 1 ? 'st' : item.monthly_sequence % 10 === 2 ? 'nd' : item.monthly_sequence % 10 === 3 ? 'rd' : 'th' }} Request
                  </span>
                </th>
                }
              </tr>
              @if (item.type === 'overtime' && item.check_in !== null && item.check_in !== undefined && item.check_in
              !== '') {
              <tr style="text-align: center;">
                <th></th>
                <td>
                  <small> Start Time </small><br> {{item.check_in}}
                </td>
                <td>
                  <small> End Time </small><br> {{item.check_out}}
                </td>
                <td>
                  <small> Hours </small><br> {{item.overtime}}
                </td>
                <td>
                </td>
              </tr>
              }
              <tr>
                <th>Request Title:</th>
                <!-- <td *ngIf="item.type === 'overtime'">{{item.check_in}} <br> {{item.check_out}} <br> {{item.overtime}}
                      </td> -->
                <td colspan="4" [innerHTML]="item.reason"></td>
              </tr>
              @if (item.status !== 'pending') {
              <tr>
                <th>Authorization</th>
                <td colspan="4">
                  <div class="auth-card-flex">
                    <div class="auth-card-main">
                      <div class="auth-cards">
                        <div class="auth-card-head mb-2">
                          <div class="auth-img" [ngClass]="{
                            'circle-bordercolor-accept': item.status === 'approved',
                            'circle-bordercolor-reject': item.status === 'rejected'
                          }">
                            <img
                              [src]="item.admin.profile_image ? item.admin.profile_image : 'assets/images/question.jpg'"
                              alt="Missing Image" />
                          </div>
                        </div>
                        <div class="auth-body ">
                          <h1>{{ item.admin.first_name }} {{ item.admin.last_name }}</h1>
                          <h2>{{ item.updated_at | date:'MMM dd, yyyy' }}
                            <img data-toggle="modal" data-target="#leavereason" (click)="detailAdmin(item)"
                              src="../../../assets/theme1/info-circle.png" alt="Missing icon">
                          </h2>
                          @if (item.status) {
                          <p [ngClass]="{'rejected-case': item.status === 'rejected'}">
                            <img
                              [src]="'../../../assets/theme1/' + (item.status === 'approved' ? 'check-circle.png' : 'cross-icon.png')"
                              alt="Missing icon">
                            {{ item.status | titlecase }}
                          </p>
                          }
                          <!-- <p class="rejected-case" *ngif="item.status == 'rejected'">
                                        <img src="../../../assets/theme1/cross-icon.png" alt="Missing icon">
                                        {{ item.status | titlecase }}
                                      </p> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              }
            </tbody>
          </table>
          <div class="modal fade" id="leavereason" tabindex="-1" role="dialog" aria-labelledby="leavereasonLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
              <div class="modal-content ">
                <div class="modal-header " [ngClass]="{
                  'approve-reason-head': Admin_detail?.status === 'approved',
                  'reject-reason-head': Admin_detail?.status === 'rejected'
                }">
                  <h5 class="modal-title" id="leavereasonLabel">Reason</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body info-modal-body">
                  <div class="row">
                    <div class="col-12">
                      <div class="modal-image reason-image">
                        <img
                          [src]="'../../../assets/theme1/' + (Admin_detail?.status  === 'approved' ? 'green.png' : 'reason-modal.png')"
                          alt="Missing icon" />
                        <!-- <h1 *ngif="item.status === 'approved'">Your Request is Approved?</h1>
                                    <h1 *ngif="item.status === 'rejected'">Why Your Request is Rejected?</h1> -->
                      </div>
                    </div>
                    <div class="col-4 p-0">
                      <div class="col-head reason-head" [ngClass]="{
                        'reason-head-bgcolor-approve': Admin_detail?.status === 'approved',
                        'reason-head-bgcolor-reject': Admin_detail?.status === 'rejected'
                      }">
                        Admin
                      </div>
                    </div>
                    <div class="col-8 p-0">
                      <div class="col-data reason-body admin-name-dep">
                        {{Admin_detail?.admin.first_name}} {{ Admin_detail?.admin.last_name }}
                        <span>{{Admin_detail?.admin.department}} </span>
                      </div>
                    </div>
                    <div class="col-4 p-0">
                      <div class="col-head reason-head" [ngClass]="{
                        'reason-head-bgcolor-approve': Admin_detail?.status === 'approved',
                        'reason-head-bgcolor-reject': Admin_detail?.status === 'rejected'
                      }">
                        Status
                      </div>
                    </div>
                    <div class="col-8 p-0">
                      <div class="col-data reason-body ">
                        <!-- <img src="../../../assets/theme1/cross-icon.png" alt="Missing icon"> -->
                        {{Admin_detail?.status |titlecase}}
                      </div>
                    </div>
                    <div class="col-4 p-0">
                      <div class="col-head reason-head" [ngClass]="{
                        'reason-head-bgcolor-approve': Admin_detail?.status === 'approved',
                        'reason-head-bgcolor-reject': Admin_detail?.status === 'rejected'
                      }">
                        Action Date
                      </div>
                    </div>
                    <div class="col-8 p-0">
                      <div class="col-data reason-body">
                        {{Admin_detail?.updated_at | date:'MMM dd, yyyy'}}
                      </div>
                    </div>
                    <div class="col-4 p-0">
                      <div class="col-head description-body reason-head" [ngClass]="{
                        'reason-head-bgcolor-approve': Admin_detail?.status === 'approved',
                        'reason-head-bgcolor-reject': Admin_detail?.status === 'rejected'
                      }">
                        Reason
                      </div>
                    </div>
                    <div class="col-8 p-0">
                      <div class="col-data description-body reason-body">
                        {{Admin_detail?.admin_reason}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      }

    </div>
  </div>
</main>